var WatermarkText = 'Search';
var lightText = '#616161';
var typeText = '#2c2c2c';
var searchClicked = false;
var displayCount = 6;//Sets how many search suggestions will be display to the user.

$(function () {
    $('#txtSearch').css('color', lightText).bind('focus', function (event) {
        if ($(event.target).val() == WatermarkText) {
            $(event.target).val('').css('color', typeText);
        }
    }).bind('blur', function (event) {
        if ($.trim($(event.target).val()) == '') {
            $(event.target).val(WatermarkText).css('color', lightText);
        }
    }).val(WatermarkText).keypress(function (e) {
        var code = e.which;
        if (code == 13) {
            e.preventDefault();
            Search(this);
        }
    }).autocomplete({
        minLength: 3,
        delay: 500,
        focus: function (event, ui) {
            this.value = ui.item.term;
            event.preventDefault();
        },
        messages: {
        noResults: '',
        results: function() {}
        },
        open: function () {
            $(this).data("ui-autocomplete").menu.element.addClass("autocomplete").css("z-index", "1006");
        },
        appendTo: $("#pnlSearch"),
        select: function (event, ui) {
            this.value = ui.item.term;
            event.preventDefault();
            Search(this);
        },
        source: function (req, resp) {
            $.ajax({
                type: "POST",
                url: "/Header/SearchAutoComplete",
                dataType: "json",
                data: { searchTerm: req.term, productDisplayCount : displayCount},
                timeout: 15000,
                async: true,
                success: function (result) {
                    var suggestions = [];
                    $.each(result, function (i, val) {
                        suggestions.push({
                            term: val.SearchTerm,
                            count: val.ResultCount                            
                        });
                    });
                    
                    resp(suggestions);
                }
            });
        }
    }).data("ui-autocomplete")._renderItem = function (ul, item) {
        var re = new RegExp("(" + this.term + ")", "gi");
        return $("<li></li>")
            .data("ui-autocomplete-item", item)
            .append("<a><div class='searchAutoLeft'>" + item.term.replace(re, "<strong>$1</strong>") + "</div><div class='searchAutoRight'>" + item.count + " results</div><div class='clear'></div></a>")
            .appendTo(ul);
    };
    $("#submitSearch").on("click", function (e) {
        e.preventDefault();
        Search(this);
    });
});

function Search(e) {

    if (e.id != "submitSearch") {
        $("#submitSearch").trigger("click");
        return false;
    }
    var searchText = $.trim($('.searchTextbox').val());
    if (searchText == "") {
        return false;
    }
    searchClicked = true;
    $.ajax({
        type: "POST",
        url: "/Header/Search",
        dataType: "json",
        data: { searchText: searchText },
        timeout: 15000,
        async: true,
        success: function (result) {
            window.location.replace(result.url);
        }
    });
}

function variableDefined(name) {
    return typeof this[name] !== 'undefined';
}